import { lazy, Suspense } from 'react';
import PageFallback from 'components/PageFallback';

let Settings = lazy(() => import('./Settings'));

export async function lazySettingsLoader() {
    const componentModule = await import('./Settings');
    Settings = componentModule.default as any;

    return null;
}

export function LazySettings() {
    return (
        <Suspense fallback={<PageFallback />}>
            <Settings />
        </Suspense>
    );
}
